import { PlayerType } from './types';

export const getPlayerType = (url: string): PlayerType => {
  if (url.includes('https://vimeo.com/')) {
    return PlayerType.VIMEO;
  }
  if (url.includes('https://www.youtube.com/') || url.includes('youtu.be')) {
    return PlayerType.YOUTUBE;
  }
  if (url.includes('youku.com')) {
    return PlayerType.YOUKU;
  }
  return PlayerType.NONE;
};

export const getVimeoId = (url: string): string => {
  const match = /vimeo.*\/(\d+)/i.exec(url);
  if (match) {
    return match[1];
  }
  return '';
};

export const getYoutubeId = (url: string): string => {
  let videoId = url.split('v=')[1] || url.split('youtu.be/')[1];

  const ampersandPosition = videoId.indexOf('&');
  if (ampersandPosition !== -1) {
    videoId = videoId.substring(0, ampersandPosition);
  }
  return videoId;
};

export const getYoukuId = (url: string): string => {
  const match = /id_(\w+)/i.exec(url);
  if (match) {
    return match[1];
  }
  return '';
};
